<template>
    <div class="bubbles_wrapper" data-chart="bubbles">
        <div class="bubble_container" v-for="(bubbleObj, bubbleKey) in bubblesArray">
            <div class="bubble" :style="{ width: bubbleObj.size + 'px', height: bubbleObj.size + 'px'}">
                <div class="bubble_tooltip" v-if="bubblesTooltips[bubbleObj.label] != undefined">
                    <div class="tooltip_title">
                        {{bubblesTooltips[bubbleObj.label].title}}
                    </div>
                    <div class="tooltip_source">
                        <i>Data Source : </i>{{bubblesTooltips[bubbleObj.label].source}}
                    </div>
                    <div class="tooltip_type">
                        <i>Data Type : </i>{{bubblesTooltips[bubbleObj.label].type}}
                    </div>
                </div>
                <div class="bubble_label">
                    {{bubbleObj.label}}
                    <div class="bubble_value" v-if="indicatorUnit != '%'">
                        {{bubbleObj.value.toFixed(0)}} {{indicatorUnit}}
                    </div>
                    <div class="bubble_value" v-else>
                        {{bubbleObj.value.toFixed(3)}} {{indicatorUnit}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import axios from 'axios'
    import {_} from 'underscore'

    import Vuetify from 'vuetify'
    Vue.use(Vuetify)
    import 'vuetify/dist/vuetify.min.css'

    export default {
        components: {
            
        },

        props: {
            chartID: {
                type: String,
                default: function () {
                    return 'BubblesGraph'
                }
            },
            bubblesData: {
                type: Array,
                default: function (){
                    return [];
                }
            },
            indicatorUnit: {
                type: String,
                default: function (){
                    return ""
                }
            }
        },
        data: function () {
            return {
                maxBubbleSize: 150,
                maxArea: Math.PI * Math.pow(140, 2),
                bubblesArray: [],
                bubblesTooltips: {}
            }
        },
        
        mounted () {
            var self = this;
            this.renderBubblesGraph();
        },
        methods: {
            renderBubblesGraph: function (){
                var self = this;

                if(this.bubblesData.length > 0){
                    var maxValue = this.bubblesData[0].total;

                    var tmpBubbles = [];
                    _.each(this.bubblesData, function (bubbleObj){
                        var bubbleAreaSize = (bubbleObj.total * self.maxArea) / maxValue;
                        var bubbleSize = Math.sqrt(bubbleAreaSize/Math.PI);

                        tmpBubbles.push({
                            area: bubbleAreaSize,
                            size: bubbleSize,
                            label: bubbleObj.cityID,
                            value: bubbleObj.total
                        })
                    })

                    this.bubblesArray = JSON.parse(JSON.stringify(tmpBubbles));
                    this.bubblesTooltips = JSON.parse(JSON.stringify(UTILS.REAL_ESTATE_TOOLTIPS));
                    console.log("bubblesTooltips", this.bubblesTooltips);
                }
            },

            
        },
        watch: {
            bubblesData: function () {
                if(this.bubblesData[0] !== undefined) {
                    this.renderBubblesGraph();
                }
            },
        }
    }
</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    .bubbles_wrapper{
        width: 100%;
        height: 100%;
        position: relative;
        text-align: center;
        .bubble_container{
            margin-top: 0px;
            width: 230px;
            height: 200px;
            display: inline-block;
            vertical-align: top;
            text-align: center;
            position: relative;
            
            .bubble{
                border-radius: 200px;
                background: $colorOrange;
                position: absolute;
                left: 50%;
                bottom: 0px;
                transform: translate(-50%, 0);
                display: inline-block;
                vertical-align: top;
                cursor: pointer;
                .bubble_tooltip{
                    display: none;
                    position: absolute;
                    left: 50%;
                    color: #29264C;
                    width: 260px;
                    text-align: left;
                    bottom: 50%;
                    padding: 16px 20px;
                    background: #fff;
                    z-index: 100;
                    border-radius: 4px;
                    box-shadow: 0px 0px 51px 0px rgba(40, 24, 88, 0.31), 0px 0px 18.616px 0px rgba(40, 24, 88, 0.18), 0px 0px 9.038px 0px rgba(40, 24, 88, 0.14), 0px 0px 4.43px 0px rgba(40, 24, 88, 0.11), 0px 0px 1.752px 0px rgba(40, 24, 88, 0.08);
                    transform: translate(-50%, 0%);
                    font-size: 14px;
                    .tooltip_title{
                        font-weight: 700;
                    }
                    .tooltip_source{
                        margin: 6px 0;
                        padding: 6px 0;
                        border-top: 1px solid #BAC6DF;
                        border-bottom: 1px solid #BAC6DF;
                    }
                }

                &:hover{
                    z-index: 100;
                    .bubble_tooltip{
                        display: block;
                    }
                }
                
                .bubble_label{
                    position: absolute;
                    left: 50%;
                    top: 100%;
                    margin-top: 6px;
                    text-align: center;
                    transform: translate(-50%, 0);
                    font-size: 16px;
                    color: #fff;
                    font-weight: 700;
                    .bubble_value{
                        white-space: nowrap;
                        color: $colorOrange;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// components/bubblesGraph.vue